import { motion } from 'framer-motion';
import Section from '../components/Section';
import AuthForm from '../components/AuthForm';

const AuthPage = () => {
  return (
    <Section className="pt-28">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto"
      >
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Welcome to SportsFuture</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Click Connect Wallet, then sign a message to verify you control it. Applicants
            are recorded when they submit a form. Assigned admin wallets click Sign in as
            Admin after connecting.
          </p>
        </div>
        
        <AuthForm />
      </motion.div>
    </Section>
  );
};

export default AuthPage;